import i18n from '@/i18n'

export default [
  {
    path: '/configurations/:configurationId/virtual-terminal',
    component: () => import(/* webpackChunkName: "VirtualTerminal" */ '@/views/VirtualTerminal.vue'),
    props: (route) => ({ ...route.params }),
    meta: {
      permissions: ['Portal.Moto.Create'],
      menu: {
        index: 65,
        activeWhen: ['virtualTerminalOrder', 'virtualTerminalSettings'],
        title: i18n.t('label.virtualTerminal'),
        icon: ['fal', 'money-check-edit-alt'],
        hasSelectedContext: ['business', 'merchant', 'configuration'],

        // Hide the VT menu when it is switched off:
        canShow: ({ context }) => (typeof context.configuration?.switches?.virtualTerminalMenuEnabled !== 'undefined')
          ? context.configuration?.switches?.virtualTerminalMenuEnabled : true
      }
    },
    children: [
      {
        path: '',
        name: 'virtualTerminalOrder',
        component: () => import(/* webpackChunkName: "VirtualTerminal" */ '@/components/VirtualTerminal/Order/VirtualTerminalOrder.vue'),
        meta: {
          permissions: ['Mapi.Merchant.Read', 'Portal.Moto.Create', 'Portal.Settings.Read', 'Portal.Terminals.Read'],
          // shortcut: 'g v t o',
          page: {
            title: i18n.t('label.virtualTerminalOrder')
          },
          menu: {
            routeName: 'virtualTerminalOrder',
            routeParams: context => context.isSelected('configuration') ? ({ 'configurationId': context.configuration.id }) : {},
            activeWhen: ['virtualTerminalOrder'],
            title: i18n.t('label.virtualTerminalOrder'),
            hasSelectedContext: ['business', 'merchant', 'configuration']
          }
        }
      }, {
        path: 'settings',
        name: 'virtualTerminalSettings',
        component: () => import(/* webpackChunkName: "VirtualTerminal" */ '@/components/VirtualTerminal/Settings/VirtualTerminalSettings.vue'),
        meta: {
          permissions: ['Portal.Settings.Read', 'Portal.Settings.Update'],
          // shortcut: 'g v t s',
          page: {
            title: i18n.t('label.virtualTerminalSettings')
          },
          menu: {
            routeName: 'virtualTerminalSettings',
            routeParams: context => context.isSelected('configuration') ? ({ 'configurationId': context.configuration.id }) : {},
            activeWhen: ['virtualTerminalSettings'],
            title: i18n.t('label.virtualTerminalSettings'),
            hasSelectedContext: ['business', 'merchant', 'configuration']
          }
        },
        props: true
      }
    ]
  }
]
